import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import {XMarkIcon} from "@heroicons/react/24/solid";

const Modal = ({ isOpen, onClose, children, className}) => {
    if (!isOpen) {
        return null;
    }

    const handleOverlayClick = (e) => {
        // 포탈 모달의 React 이벤트가 트리 상위(예: JsGrid 행 onRowClick)로
        // 전파되는 것을 막고 오버레이 클릭 시에만 닫히도록 처리
        e.stopPropagation();
        onClose?.();
    };

    return ReactDOM.createPortal(
        <div className={`modal-overlay ${className}`} onClick={handleOverlayClick}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <div><XMarkIcon className={`h-5 modal-close-button`} onClick={onClose}/></div>
                {children}
            </div>
        </div>,
        document.body
    );
};

export default Modal;